import React from "react"
import {} from "react-bootstrap"
import { useDispatch } from "react-redux"
import { getDocumentRequestByPage } from "../../actions/documentModalActions"

const PrevNextButtons = (props) => {
	const { currentDocId: id, currentPage, totalPages, getRequiredDocument } = props

	const dispatch = useDispatch()
	const handleDocumentFlipping = (isNext) => {
		const page = isNext ? currentPage + 1 : currentPage - 1
		dispatch(getDocumentRequestByPage({ id, page }))
	}

	return (
		<div>
			<span>Page</span>
			<button
				className={currentPage <= 1 ? "prev-next-disabled" : "prev-next-icon-btn"}
				disabled={currentPage <= 1}
				onClick={() => handleDocumentFlipping(false)}
			>
				<i className="bi bi-caret-left-square-fill"></i>
			</button>
			<button
				className={totalPages === currentPage ? "prev-next-disabled" : "prev-next-icon-btn"}
				disabled={totalPages === currentPage}
				onClick={() => handleDocumentFlipping(true)}
			>
				<i className="bi bi-caret-right-square-fill"></i>
			</button>
		</div>
	)
}

export default PrevNextButtons
